const Establecimiento = props => {
    const state =  props.state;
    return(
        <>
        <h5>Establecimiento</h5>
        <span className="fst-italic">Selecciona tu Establecimiento para la Actividad de Admisión 2024</span>
        <div className="mt-2">
            <div className="row">
                <div className="col-12 col-md-12">
                    <div className="mb-2">
                        <label htmlFor="colegio_iquique" className="form-label">Iquique</label>
                        <select className="form-select form-select-sm" id="colegio_iquique" name="colegio_iqq" value={state.colegio_iqq} onChange={e => props.handleOnChangeText(e)}>
                            <option value="">Seleccione</option>
                            {
                                props.colegioIquique.map((row,index) => {
                                    return(
                                        <option key={index} value={row.codcol}>{row.nombre}</option>
                                    )
                                })
                            }
                        </select>
                        <div className="text-danger invalid-text text-start">{props.error.colegio_iqq}</div>
                    </div>
                </div>
                <div className="col-12 cols-md-12">
                    <div className="mb-2">
                        <label htmlFor="colegio_alto_hospicio" className="form-label">Alto Hospicio</label>
                        <select className="form-select form-select-sm" id="colegio_alto_hospicio" name="colegio_ah" value={state.colegio_ah} onChange={e => props.handleOnChangeText(e)}>
                            <option value="">Seleccione</option>
                            {
                                props.colegioAltoHospicio.map((row,index) => {
                                    return(
                                        <option key={index} value={row.codcol}>{row.nombre}</option>
                                    )
                                })
                            }
                        </select>
                        <div className="text-danger invalid-text text-start">{props.error.colegio_ah}</div>
                    </div>
                </div>
                <div className="col-12 col-md-12">
                    <div className="mb-2">
                        <label htmlFor="otra_comuna" className="form-label">Otra comuna de la región</label>
                        <select className="form-select form-select-sm" id="otra_comuna" name="colegio_otra_comuna" value={state.colegio_otra_comuna} onChange={e => props.handleOnChangeText(e)}>
                            <option value="">Seleccione</option>
                            {
                                props.colegioOtrasComunas.map((row,index) => {
                                    return(
                                        <option key={index} value={row.codcol}>{row.nombre}</option>
                                    )
                                })
                            }
                        </select>
                        <div className="text-danger invalid-text text-start">{props.error.colegio_otra_comuna}</div>
                    </div>
                </div>
                <div className="col-12 col-md-12">
                    <div className="mb-2">
                        <label htmlFor="otro_establecimiento" className="form-label">Otro Establecimiento, Empresa u Organización</label>
                        <input className="form-control form-control-sm" id="otro_establecimiento" name="colegio_otro_establecimiento" placeholder="Indique a la intitucion a la que pertenece" 
                            value={state.colegio_otro_establecimiento} onChange={e => props.handleOnChangeText(e)}></input>
                        <div className="text-danger invalid-text text-start">{props.error.colegio_otro_establecimiento}</div>
                    </div>
                </div>
            </div>
        </div> 
        </>
    )
}

export default Establecimiento;